import { Clock, WebGLRenderer } from 'three'


export class Engine {
el: HTMLElement
renderer: WebGLRenderer
clock = new Clock()
dt = 0

constructor(el: HTMLElement) {
  this.el = el

  this.renderer = new WebGLRenderer({
    antialias: true,
    alpha: false,
    powerPreference: 'high-performance',
  })

  // Force black from the very first possible moment.
  this.renderer.setClearColor(0x000000, 1)
  this.renderer.setClearAlpha(1)
  this.renderer.domElement.style.backgroundColor = '#000'

  this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
  this.renderer.setSize(el.clientWidth, el.clientHeight)

  // Immediately clear once, so the canvas is black even before your first scene render.
  this.renderer.clear(true, true, true)

  el.appendChild(this.renderer.domElement)
  window.addEventListener('resize', this.onResize)
}



onResize = () => this.renderer.setSize(this.el.clientWidth, this.el.clientHeight)


start(loop: () => void) {
const tick = () => {
this.dt = this.clock.getDelta()
loop()
requestAnimationFrame(tick)
}
tick()
}
}